import {
  GET_SHIPPING_SUPPLIERS,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initalShippingSupplier = {
  shippingSuppliers: [],
  shippingSupplierCount: 0,
  page: 1,
  search: "",
};

function shippingSupplierReducer(state = initalShippingSupplier, action) {
  switch (action.type) {
    case GET_SHIPPING_SUPPLIERS:
      return {
        ...state,
        shippingSuppliers: action.payload.suppliers.map((supplier) => {
          return {
            ...supplier,
            updatedAtFormatted: moment(supplier.createdAt).format("ll"),
          };
        }),
        shippingSupplierCount: action.payload.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
}

export default shippingSupplierReducer;
